import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { Tooltip } from 'primeng/tooltip';
import { trigger, transition, style, animate } from '@angular/animations';
import { ClipboardService } from '@brighthub/utils';
import { Message } from '../../models/copilot.models';
import { ChatMessageTraceComponent } from '../chat-message-trace/chat-message-trace.component';
import { ButtonDirective } from 'primeng/button';
import { ChatMessageFeedbackComponent } from '../chat-message-feedback/chat-message-feedback.component';

@Component({
  selector: 'lib-chat-message',
  imports: [
    CommonModule,
    MarkdownModule,
    Tooltip,
    ChatMessageTraceComponent,
    ButtonDirective,
    ChatMessageFeedbackComponent,
  ],
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  animations: [
    trigger('messageAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px)' }),
        animate(
          '200ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageComponent {


  private _clipboard = inject(ClipboardService);



  @Input() message!: Message;
  /** When set (e.g. search highlights), used instead of `message.content` for markdown. */
  @Input() markdownBody?: string | null;
  @Input() copilotName = 'BrightNav';
  @Input() userDisplayName = 'User';
  @Input() userInitials = 'U';
  @Output() scrollDown = new EventEmitter<string>();
  @Input() hideFeedback!: boolean;
  /** When true, shows "BrightNav is thinking..." below the message content (e.g. during a pause in streaming). */
  @Input() showThinkingBelow = false;
  /** When true, plays a wiggle animation on the assistant avatar (e.g. when stream ends). */
  @Input() wiggleAvatar = false;

  copyToClipboard(text: string): void {
    this._clipboard.copy(text);
  }

  get markdownData(): string {
    const m = this.markdownBody;
    if (m != null && m.length > 0) {
      return m;
    }
    return this.message.content;
  }

  scrollToBottom(behavior: 'smooth' | 'auto' = 'smooth'): void {
    this.scrollDown.emit(behavior);
  }

}

